// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","wrapper":"_2ybCo","s4lwrapper":"_1Qzt8","s4Lwrapper":"_1Qzt8"};